import 'normalize.css';
import 'v1/fonts/diamante.sass';
import 'v1/fonts/vanguardian.sass';

import 'jquery-ujs';
import 'jquery.role/lib/jquery.role';

// modals https://github.com/kylefox/jquery-modal
import 'jquery-modal/jquery.modal.min.css';
import 'jquery-modal/jquery.modal.min';

// Social sharing buttons https://github.com/firstandthird/social-share-button/blob/HEAD/example/index.html
import 'social-share-button';

// https://github.com/vctrfrnndz/jquery-accordion
import 'jq-accordion/dist/css/jquery.accordion.css';

// Tabs https://github.com/ltebean/tabs
import tabs from 'tabs';

// https://github.com/liabru/jquery-match-height
import 'jquery-match-height';

// application bundle
import 'v1/stylesheets/application.sass';

// Libs
import sticky from 'jquery-sticky';
import tooltip from 'tooltip';

// import fixedSubmit from '../v1/libs/application/fixed_submit';
import $accordion from '../v1/libs/application/accordion';
import $progressBar from '../v1/libs/application/progress_bar';
import $toggleSlide from '../v1/libs/application/toggle_slide';
import customSelect from '../v1/libs/application/custom_select';
import disableClick from '../v1/libs/application/disable_click';
import formsController from '../v1/libs/application/forms_controller';
import imagesLoadedHandler from '../v1/libs/application/imagesloaded';
import inputMask from '../v1/libs/application/input_mask';
import modalGameRules from '../v1/libs/application/modal_game_rules';
import modalPlayer from '../v1/libs/application/modal_player';
import modals from '../v1/libs/application/modals';
import rail from '../v1/libs/application/rail';
import scrollContest from '../v1/libs/application/next_contest';
import searchPlayers from '../v1/libs/application/search_players';
import toggleMenu from '../v1/libs/application/toggle_menu';
import videoPlayer from '../v1/libs/application/video_player';

const tooltipConfig = {
  showDelay: 100,
  offset: {
    x: 5,
    y: 0,
  },
  style: {
    'background-color': '#000',
    // 'margin-top': '-5px',
    position: 'absolute',
    color: 'white',
    border: 'none',
    padding: '10px',
  },
};

function libsInit() {
  const $container = $('@body');
  const $tabContainer = document.querySelectorAll('.js-tab-container');

  $accordion($container, $('@accordion'));
  $progressBar($container);
  $toggleSlide($container);
  customSelect($container);
  disableClick($container);
  formsController($container);
  imagesLoadedHandler($container);
  inputMask($container);
  modalGameRules($container);
  modalPlayer($container);
  modals($container);
  rail($container);
  scrollContest($container);
  searchPlayers($container);
  toggleMenu($container, $('@toggleMenu'));
  tooltip(tooltipConfig);

  $('@sticky').sticky({ topSpacing: 60 });
  $('@sticky').on('sticky-start', () => {
    $('.make_picks_header__arrow').css({ 'z-index': '100' });
  });

  $('@sticky').on('sticky-end', () => {
    $('.make_picks_header__arrow').css({ 'z-index': '350' });
  });

  if ($('#player').length > 0) {
    videoPlayer();
  }

  if ($tabContainer !== null) {
    for (let i = 0; i < $tabContainer.length; ++i) {
      tabs($tabContainer[i]);
    }

    $('.pick_breakdown_streak__avatar').matchHeight();

    $('.tab').on('click', () => {
      $('.pick_breakdown_streak__avatar').matchHeight();
    });
  }
}

$(document).ready(libsInit);

window.$ = $; //eslint-disable-line

// Support component names relative to this directory:
const componentRequireContext = require.context('v1/components', true);
const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);
